var $ = window.$;
// animated spinner used to represent a page level "loading" state
export default function(id) {
	this.$outer = $('#' + id);
	this.$inner = [];
	this.$path = [];
	this.offset = 177.18583;
	var _isStopped = false;

	this.innerRotate = function(context) {
		var that = context;
		if (_isStopped) {
			_isStopped = false;
			return;
		}

		that.$inner
			.velocity({
				'rotateZ': '+=135',
			}, {
				duration: 600,
				easing: 'easeInOutSine',
			})
			.velocity({
				rotateZ: '+=315',
			}, {
				duration: 400,
				easing: 'easeInOutSine',
			});

		// animate offset
		that.$path
			.velocity({
				'stroke-dashoffset': that.offset / 4
			}, {
				duration: 600,
				easing: 'easeInOutSine',
			})
			.velocity({
				'stroke-dashoffset': (that.offset - that.offset / 10)
			}, {
				duration: 400,
				easing: 'easeInOutSine',
				complete: function() {
					// loop animation
					setTimeout(function() {
						that.innerRotate(that);
					}, 40);
				}
			});
	};

	this.stop = function(booReset) {
		_isStopped = true;
		$('body').removeClass('is-spinning');
		this.$outer.hide();

		if (booReset) this.reset();
	};

	this.start = function() {
		_isStopped = false;
		$('body').addClass('is-spinning');
		this.innerRotate(this);
		this.$outer.show();
	};

	this.reset = function() {
		this.$path.removeAttr('style');
		this.$inner.removeAttr('style');
	};

	var _cacheSelectors = function() {
		this.$outer = $('#' + id);
		this.$inner = this.$outer.find('.js-spinner-inner');
		this.$path = this.$outer.find('.js-spinner-path');
	};

	this.init = function() {
		_cacheSelectors.call(this);
	};
}